import styled from "styled-components";
import { backgroundBasedOnSubType } from "../util";
import { COLORS, FONTS } from "@bikdotai/bik-component-library";

export const MessageNodeStyle = styled.div.attrs(
  (props: { subType: string; channel: string }) => props
)`
  .customNode {
    &__header {
      &__icon {
        background-color: ${(props) =>
          backgroundBasedOnSubType(props.subType, props.channel)};
      }
      &__menu {
        width: 10px;
      }
    }
    &__child-nodes {
      margin-top: 16px;
      border: 1px solid ${COLORS.stroke.primary};
      border-bottom: 0;
      border-radius: 4px;
      background: ${COLORS.surface.subdued};
    }
  }
`;

export const Header = styled.div.attrs(
  (props: { noButtons: boolean }) => props
)`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${COLORS.background.base};
  gap: 8px;
  border-left: 1px solid ${COLORS.stroke.primary};
  border-right: 1px solid ${COLORS.stroke.primary};
  border-top: 1px solid ${COLORS.stroke.primary};
  border: ${(props) =>
    props.noButtons ? `1px solid ${COLORS.stroke.primary}` : ""};
  padding: 8px;
`;

export const ImgBg = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLORS.stroke.primary};
  border-radius: 4px;
  // background: ${COLORS.background.base};
`;

export const Title = styled.div`
  color: ${(props) => props.theme.colors.content.secondary};
  ${(props) => props.theme.fonts.buttonRegular};
`;

export const Caption = styled.div`
  color: ${(props) => props.theme.colors.content.secondary};
  ${(props) => props.theme.fonts.bodyCaption};
`;

export const Child = styled.div``;

export const Gap = styled.div`
  margin-top: 16px;
`;

export const HandoverPlaceholder = styled.div`
  border: 1px dashed ${COLORS.stroke.primary};
  border-radius: 4px;
  padding: 6px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  font-size: 12px;
  color: ${COLORS.content.placeholder};
`;

export const TicketFormSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

export const TicketFormSummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLORS.surface.subdued};
  padding: 6px 8px;
  min-height: 32px;
  width: 100%;
  box-sizing: border-box;
`;

export const TicketFormSummaryLabel = styled.span`
  font-size: ${FONTS.caption.fontSize}px;
  font-weight: ${FONTS.caption.fontWeight};
  line-height: ${FONTS.caption.lineHeight}px;
  color: ${COLORS.content.placeholder};
  flex-shrink: 0;
  max-width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TicketFormSummaryValue = styled.span<{ isVariable?: boolean }>`
  font-size: ${FONTS.caption.fontSize}px;
  font-weight: ${FONTS.caption.fontWeight};
  line-height: ${FONTS.caption.lineHeight}px;
  color: ${(props) =>
    props.isVariable ? COLORS.content.brand : COLORS.content.primary};
  text-align: right;
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TicketFormSummaryDivider = styled.div`
  width: 1px;
  height: 8px;
  background: #d9d9d9;
  border-radius: 4px;
  margin: 0 16px;
`;

export const Main = styled.div.attrs(
  (props: { idx: number; length: number }) => props
)`
  background: ${COLORS.surface.subdued};
  // border: 1px solid ${COLORS.stroke.primary};
  border-left: 1px solid ${COLORS.stroke.primary};
  border-right: 1px solid ${COLORS.stroke.primary};
  border-bottom: ${(props) =>
    props.idx === props.length - 1
      ? `1px solid ${COLORS.stroke.primary}`
      : ""};
  border-top: 1px solid ${COLORS.stroke.primary};
`;

export const ProductCatalogHeader = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid ${COLORS.stroke.primary};
`;

export const TitleContainer = styled.div`
  background: ${COLORS.background.base};
  padding: 12px 8px 12px 8px;
`;
export const ImageContainer = styled.div``;

export const TitleAndSubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-itens: center;
`;

export const Wrapper = styled.div`
  background: ${COLORS.surface.subdued};
  border-left: 1px solid ${COLORS.stroke.primary};
  border-right: 1px solid ${COLORS.stroke.primary};
`;

// ─── AttachmentGrid styles for multi-image rendering ───────────────────────
export const AttachmentGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  background: ${COLORS.surface.subdued};
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 0;
`;

export const AttachmentMainImage = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
`;

export const AttachmentThumbnailGrid = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns || 4}, 1fr);
  gap: 4px;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const AttachmentThumbnail = styled.div`
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
  background: ${COLORS.background.base};
  border: 1px solid ${COLORS.stroke.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${COLORS.stroke.brand};
  }

  &.count-badge {
    background: ${COLORS.scrim.standard};
    color: ${COLORS.text.white};
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

/** Dotted "Add an action" button */
export const AddActionButton = styled.div`
  border: 1px dashed ${COLORS.stroke.primary};
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${COLORS.content.placeholder};
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
`;
